import T from 'i18n-react'

import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  get,
  post
} from 'helpers/RequestUtil'

import {
  FETCH_PROJECT_SCHEDULE,
  POST_PROJECT_SCHEDULE
} from './constants'

import {
  fetchProjectSchedule as fetchProjectScheduleAction,
  fetchProjectScheduleStart,
  fetchProjectScheduleSuccess,
  fetchProjectScheduleError,
  postProjectScheduleStart,
  postProjectScheduleSuccess,
  postProjectScheduleError,
  updateProjectScheduleChange,
  resetProjectScheduleChange
} from './actions'

import {
  overwriteTables
  //updateTables
} from 'containers/Entity/actions'

import {
  error as errorAction
} from 'containers/App/Notification/actions'

import { projectScheduleSelector } from './selectors'

function getEntityData(data){
  if(data.entities.project_schedule_views){
    const schedules = Object.values(data.entities.project_schedule_views)
    if(schedules.length > 0){
      const lastIndex = schedules.length - 1
      if(schedules[lastIndex].data){
        return schedules[lastIndex].data
      }
    }
  }
  return {}
}

function* fetchProjectSchedule(action) {
  try {
    const { projectId } = action
    yield put(fetchProjectScheduleStart())
    const data = yield call(
      get,
      `/api/fulcrum/projects/${projectId}/schedules`
    )
    // Add new data to entities and results
    yield put(overwriteTables(data))
    // Put new schedule object into ProjectScheduleChange (these are the values that change when the form is edited)
    yield put(updateProjectScheduleChange(getEntityData(data)))
    yield put(fetchProjectScheduleSuccess())
  } catch(error) {
    yield put(errorAction('Error fetching schedule for project'))
    yield put(fetchProjectScheduleError(error))
  }
}

function* watchFetchProjectSchedule(){
  yield takeEvery(FETCH_PROJECT_SCHEDULE, fetchProjectSchedule)
}

function* postProjectSchedule(action){
  try{
    const { projectId, params } = action
    yield put(postProjectScheduleStart())
    yield call(
      post,
      'project_schedules',
      params,
      `/api/fulcrum/projects/${projectId}/schedules`
    )
    yield put(postProjectScheduleSuccess())
    // Refetch AE Details for selected project
    yield put(fetchProjectScheduleAction(projectId))
  } catch(error) {
    yield put(errorAction(T.translate('project.schedule.postError')))
    yield put(postProjectScheduleError(error))
    // Replace the changed values with the unchanged ones again
    const detailObject = yield select(projectScheduleSelector)
    if(Object.keys(detailObject) < 1){
      yield put(resetProjectScheduleChange())
    } else {
      yield put(updateProjectScheduleChange(detailObject))
    }
  }
}

function* watchPostProjectSchedule(){
  yield takeEvery(POST_PROJECT_SCHEDULE, postProjectSchedule)
}

function* loadSagas() {
  yield all([
    fork(watchFetchProjectSchedule),
    fork(watchPostProjectSchedule)
  ])
}

export default loadSagas
